/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { NO_OPENER_REFERRER } from 'constants';

import { injectIntl, defineMessages } from 'react-intl';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

import HeaderField from '../../HeaderField/HeaderField';

import styles from './MemberSelection.module.css';

const messages = defineMessages({
  otherTenants: 'Other tenants ({tenantCount}):',
  tenantId: 'Tenant ID:',
});

const propTypes = {
  memberData: PropTypes.arrayOf(PropTypes.string),
};

const defaultProps = {
  memberData: [],
};

/**
 * Dropdown Menu for User includes username, tenant members, and Logout button currently
 */

const MemberSelection = memo(({ memberData, intl: { formatMessage } }) => {
  if (memberData.length === 0) {
    return null;
  }

  return (
    <div className={styles.memberSelection}>
      <HeaderField
        label={formatMessage(messages.otherTenants, {
          tenantCount: memberData.length,
        })}
        value=""
      />
      {memberData.map(elem => (
        <a
          href={`/preauth?tenantid=${elem}`}
          key={`link-tenant-${elem}`}
          rel={NO_OPENER_REFERRER}
          title={elem}
          className="hide">
          <HeaderField
            key={`field-tenant-${elem}`}
            value={elem}
            label={formatMessage(messages.tenantId)}
          />
        </a>
      ))}
    </div>
  );
});

MemberSelection.propTypes = propTypes;
MemberSelection.defaultProps = defaultProps;
export default injectIntl(MemberSelection);
